<div class="warp-tow-popup" [ngClass]="{ reminder: isReminder }">
  <div class="warp-popup" *ngIf="step == 1; else step2">
    <div class="popup">
      <div class="header">
        <div class="title" *ngIf="isReminder; else notReminderTitle">
          <p>
            <img src="/assets/images/popup-recipient/reminder-icon.svg" class="reminder-icon" />
          </p>
          <p translate>reminder.title</p>
        </div>
      </div>
      <div *ngIf="isUnauthorized" class="warp-active-toggle">
        <p translate>chooseRecipient.sendAll</p>
        <que-toggle [toggleState]="isSendAll.value ?? false" (toggleEvent)="changeSendAll()"></que-toggle>
      </div>
      <div *ngIf="isUnauthorized && isRecipients$() && !isAddRecipients">
        <p translate class="small-text gray">
          chooseRecipient.warnDeleteRecipients
        </p>
      </div>
      <div *ngIf="isUnauthorized && isRecipients$() && isAddRecipients">
        <p translate class="small-text gray">
          chooseRecipient.warnDeleteNewRecipients
        </p>
      </div>
      <que-select-users-input [isdisabled]="isUnauthorized && (isSendAll.value ?? false)" [canDelete]="!isAddRecipients"
        [isInPublish]="!isReminder"></que-select-users-input>
      <div *ngIf="!isReminder" class="warp-active-toggle">
        <p *ngIf="!isAddRecipients" translate>chooseRecipient.sendEmail</p>
        <p *ngIf="isAddRecipients" translate>chooseRecipient.sendEmailToNew</p>
        <que-toggle [toggleState]="sendEmail.value ?? false" (toggleEvent)="changeSendEmail()"></que-toggle>
      </div>
      <div class="contain-input" *ngIf="sendEmail.value ?? false">
        <label class="mark" translate>chooseRecipient.mailBody.subject</label>
        <input class="select" type="text" placeholder="{{ placeholder }}" matInput [formControl]="subject" />
      </div>
      <div class="contain-input" *ngIf="sendEmail.value ?? false">
        <label class="mark" translate>chooseRecipient.mailBody.message</label>
        <textarea autoresize queHighlightAtWords class="select line-height" type="text" placeholder="{{
            'chooseRecipient.mailBody.massage-placeholder' | translate
          }}" matInput [formControl]="body"></textarea>
      </div>
      <div class="contain-input" *ngIf="!isReminder && !isUnauthorized">
        <label class="mark" translate>chooseRecipient.submissionDate</label>
        <div class="warp-date">
          <div class="date-input-wrap" #dateToSelect>
            <div class="image-with-icon pointer" (click)="changeSelectedRangeIsOpened()">
              <img src="/assets/images/calendar-icon.svg" />
              <input class="date-input" placeholder="{{
                  'filter.dateRangeFilter.chooseDate' | translate
                }}" value="{{ submissionDate.value | queDate }}" readonly />
            </div>
          </div>
          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="dateToSelect"
            [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="selectedRangeIsOpened = false"
            [cdkConnectedOverlayOpen]="selectedRangeIsOpened" cdkConnectedOverlayBackdropClass="backdrop-selection"
            [cdkConnectedOverlayPositions]="positonAreaForSelectedDate">
            <que-dual-calendar-range-picker [customDateFrom]="submissionDate.value" [isPreviewTodayDisable]="true"
              (rangeChanged)="startDateRangePicked($event)" [isSingalDate]="true"></que-dual-calendar-range-picker>
          </ng-template>
          <div *ngIf="submissionDate.invalid && submissionDate.touched" class="error" translate>
            reminder.errorMassage
          </div>
        </div>
      </div>
      <ng-container *ngIf="!isReminder ; else timing"> </ng-container>
      <ng-container *ngIf="!isOpenReminder; else timing"> </ng-container>
    </div>
    <div class="footer">
      <!-- <div *ngIf="isReminder && !isUnauthorized"></div> -->
      <!-- not in amodcs *ngIf="!isReminder " else approval -->
      <div *ngIf="!isReminder">
        <div *ngIf="!isOpenReminder  && !isUnauthorized" class="reminder-btn pointer" (click)="addReminder()">
          <p translate>btns.reminder</p>
          <img src="/assets/images/popup-recipient/reminder-icon.svg" class="reminder-icon" />
        </div>
      </div>
      <div class="btns">
        <div class="btn pointer" (click)="cancel()">
          <p translate>btns.cancelPublish</p>
        </div>
        <div *ngIf="
        ((isUnauthorized && (isSendAll.value || isRecipients$())) || 
           ((!submissionDate.invalid || isReminder) && isRecipients$())) &&
              (!sendEmail.value || (!subject.invalid && !body.invalid)) &&
              ((!isReminder && !isOpenReminder) || reminderValidator());
            else disablesaveBtn
          " class="btn pointer orange" (click)="next()">
          <p *ngIf="(isReminder && !isCreated); " translate>
            btns.save
          </p>
          <p *ngIf="isAddRecipients" translate>
            btns.saveandsend
          </p>
          <p *ngIf="!isCreated && !isReminder && !isAddRecipients" translate>btns.next</p>
          <p translate *ngIf="isCreated">btns.create</p>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #step2>
  <div class="warp-popup">
    <div class="popup">
      <div class="wrapper">
        <div class="texts">

          <p translate class="beforeDistributing-title">
            chooseRecipient.beforeDistributing
          </p>
          <p translate class="small-text">chooseRecipient.areYouSure</p>
          <p translate class="small-text red">
            chooseRecipient.beforeDistributingWarning
          </p>
        </div>
        <que-select-users-input [canDelete]="false" [displayInput]="false"></que-select-users-input>
      </div>
    </div>
    <div class="footer step2">
      <div class="btns">
        <div class="btn pointer big" (click)="save()">
          <p translate>chooseRecipient.saveWithoutPublish</p>
        </div>
        <div class="btn pointer big" (click)="back()">
          <p translate>chooseRecipient.backToDetails</p>
        </div>
        <div class="btn pointer orange" (click)="publish('publish')">
          <p translate>btns.saveandsend</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #notReminderTitle>
  <div class="questionnarie-details">
    <img class="title-icon" src="/assets/images/popup-recipient/people-icon.svg" />
    <div class="warp-share-title">
      <p translate [translateParams]="{ questionnaireName: name }" class="share-title">
        chooseRecipient.name
      </p>
      <div class="folder" *ngIf="category.id != -1">
        <img src="/assets/images/definitions/folder.svg" />
        <p translate class="category" [translateParams]="{ category: category }">
          grid.categoryName
        </p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #timing>
  <input [formControl]="reminderForm.controls.content" />
  <div class="schedule" *ngIf="!isReminder; else reminderSchedule">
    <div class="flex">
      <img src="/assets/images/popup-recipient/reminder-icon.svg" class="reminder-icon" />
      <label class="mark" translate>reminder.timing.title</label>
      <!-- <P class="mini-title" translate>reminder.timing</P> -->
    </div>
    <img src="/assets/images/popup-recipient/delete-icon.svg" class="pointer" (click)="removeReminder()"
      *ngIf="isOpenReminder" />
  </div>
  <ng-template #reminderSchedule>
    <div class="contain-input">
      <label class="mark" translate>reminder.timing.title</label>
      <img src="/assets/images/popup-recipient/delete-icon.svg" (click)="removeReminder()" *ngIf="isOpenReminder" />
    </div>
  </ng-template>
  <div class="times">
    <div class="date-container">
      <div class="warp-with-label">
        <label class="mini-label" translate>reminder.timing.date</label>
        <div class="warp-date">
          <div class="date" #reminderStartDate>
            <div class="image-with-icon reminderDate" (click)="openChooseReminderDate()"
              [ngClass]="{'withEnd':reminderForm.controls.frequencyId.value && reminderForm.controls.frequencyId.value != 1}">
              <img src="/assets/images/calendar-icon.svg" />
              <!-- <input class="date-input" placeholder="{{ 'filter.dateRangeFilter.fromDate' | translate }}" value="{{
                reminderForm.controls.startDate.value | queDate }}" /> -->
              <div>
                <p>{{reminderForm.controls.startDate.value | queDate}}</p>
                <p *ngIf="reminderForm.controls.endDate.value">- {{reminderForm.controls.endDate.value | queDate}}</p>
              </div>
              <div *ngIf="!reminderForm.controls.startDate.value" translate>filter.dateRangeFilter.fromDate</div>
            </div>
          </div>
          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="reminderStartDate"
            [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="selectedReminderStartDateIsOpened = false"
            [cdkConnectedOverlayOpen]="selectedReminderStartDateIsOpened"
            cdkConnectedOverlayBackdropClass="backdrop-selection"
            [cdkConnectedOverlayPositions]="positonAreaForSelectedDate">
            <que-dual-calendar-range-picker [isPreviewTodayDisable]="true"
              [customDateFrom]="reminderForm.controls.startDate.value"
              [customDateTo]="reminderForm.controls.endDate.value ?? null"
              (rangeChanged)="startDateRangePicked($event, true)" [isSingalDate]="
              !(
                reminderForm.controls.frequencyId.value &&
                reminderForm.controls.frequencyId.value != 1
              )
            "></que-dual-calendar-range-picker>
          </ng-template>
          <div *ngIf="
            reminderForm.controls.startDate.invalid &&
            reminderForm.controls.startDate.touched
          " class="error" translate>
            reminder.errorMassage
          </div>
        </div>
      </div>
      <div class="warp-with-label">
        <label class="mini-label" translate>reminder.timing.time</label>
        <div class="warp-select pointer" #selectHour (click)="selectedHourIsOpened = true">
          <img src="/assets/images/reminder/hour.svg" />
          <div class="item hour-warp">
            <p translate>reminder.hour</p>
            <div [innerHTML]="reminderForm.controls.hour.value  | queDateHourFormatAmPm"></div>
          </div>
        </div>
      </div>
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="selectHour" [cdkConnectedOverlayHasBackdrop]="true"
        (backdropClick)="selectedHourIsOpened = false" [cdkConnectedOverlayOpen]="selectedHourIsOpened"
        cdkConnectedOverlayBackdropClass="backdrop-selection" [cdkConnectedOverlayPositions]="positonAreaForSelected">
        <div class="overlay-warp">
          <div class="item op" *ngFor="let c of hourers$ | async" (click)="chooseHour(c.id)">
            <div [innerHTML]="c.hour | queDateHourFormatAmPm"></div>
          </div>
        </div>
      </ng-template>
      <div class="warp-with-label">
        <label class="mini-label" translate>reminder.timing.frequency</label>
        <div class="warp-select pointer" #selectRepeat (click)="selectedRepetIsOpened = true">
          <img src="/assets/images/reminder/repeat.svg" />
          <div class="item" *ngIf="frequencyChoosen$()">
            <div translate [translateParams]="{ frequency: frequencyChoosen$() }">
              grid.frequencyName
            </div>
          </div>
          <div class="item" *ngIf="!frequencyChoosen$()">
            <div translate>reminder.repeat</div>
          </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="selectRepeat"
          [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="selectedRepetIsOpened = false"
          [cdkConnectedOverlayOpen]="selectedRepetIsOpened" cdkConnectedOverlayBackdropClass="backdrop-selection"
          [cdkConnectedOverlayPositions]="positonAreaForSelected">
          <div class="overlay-warp">
            <div class="item op" *ngFor="let f of frequency$()" (click)="chooseRepete(f.id)">
              <div translate [translateParams]="{ frequency: f }">
                grid.frequencyName
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #approval>
  <div>
    <div class="custom-checkbox">
      <div class="choose" (click)="appproval()" [ngClass]="{ selected: reminderForm.controls.isApproval.value }">
        <div class="inner-selected">
          <img src="/assets/images/auto-fill/vi.svg" />
        </div>
      </div>
      <p (click)="appproval()" translate>reminder.isApprovalTitle</p>
    </div>
  </div>
</ng-template>
<ng-template #disablesaveBtn>
  <div class="btn pointer orange disabled">
    <p *ngIf="!isCreated && !isAddRecipients" translate>btns.next</p>
    <p *ngIf="isAddRecipients" translate>btns.saveandsend</p>
    <p *ngIf="isCreated" translate>btns.create</p>
  </div>
</ng-template>